export interface RuntimeConfig {
  REACT_APP_BASEURL: string;
  REACT_APP_SUPERVISORBASEURL: string;
  REACT_APP_INSIGHTS_CONNECTION_STRING: string;
  REACT_APP_AD_CLIENT_ID: string;
  REACT_APP_AD_AUTHORITY_URL: string;
  REACT_APP_AD_EXT_TARGET_AUTH: string;
  REACT_APP_AD_EXT_SANDBOX_AUTH: string;
  REACT_APP_AD_INT_AUTH: string;
  REACT_APP_AD_EXT_AUTH: string;
  REACT_APP_REDIRECT_URL: string;
  REACT_APP_TARGET_LOGOFF_URL: string;
  REACT_APP_AUTHORITY_DOMAIN: string;
  REACT_APP_REQUEST_SCOPE: string;
  REACT_APP_KNOWN_AUTH: string;
  SKIP_PREFLIGHT_CHECK: string; // usually "true" | "false"
  // Datadog config
  REACT_APP_DD_APP_ID: string;
  REACT_APP_DD_CLIENT_TOKEN: string;
  REACT_APP_DD_ENV: string;
  REACT_APP_DD_LOGS_ENABLED: string;
  REACT_APP_DD_SERVICE: string;
  REACT_APP_DD_SITE: string;
  REACT_APP_DD_TRACE_ENABLED: string;
  REACT_APP_DD_VERSION: string;
  REACT_APP_DD_ALLOW_TRACE_URL: string;
  REACT_APP_DD_SESSION_RATE: string;
  REACT_APP_DD_SESSION_REPLAY_RATE: string;
  REACT_APP_DD_TRACK_RESOURCE: string;
  REACT_APP_DD_TRACK_LONG_TASK: string;
  REACT_APP_DD_USER_INTERACTION: string;
  REACT_APP_DD_TRACE_SAMPLE_RATE: string;
}
let _config: RuntimeConfig | null = null
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const response = await fetch("/config.json")
  if (!response.ok) {
    throw new Error(`Failed to load runtime config: ${response.statusText}`)
  }
  _config = await response.json()
  return _config!
}
export function getRuntimeConfig(): RuntimeConfig {
  if (!_config) {
    throw new Error(
      "Runtime config not loaded. Call loadRuntimeConfig() first."
    )
  }
  return _config
}